import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import Image from 'react-graceful-image';
import ScrollToTop from 'react-scroll-up';

import logo from './img/nn.svg';
import iconInstagram from './img/insta.svg';
import iconFb from './img/fb.svg';
import iconLinkedIn from './img/li.svg';
import './NN.css';

const shuffleArray = arr => (
  arr
    .map(a => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map(a => a[1])
);

const initial_books = [
  'jeeves_wedding_bells.jpg',
  'm.jpg',
  'fire.jpg',
];

const extra_books = [
	'4d.jpg',
	'biased.jpg',
	'cigars.jpg',
	'decisive.jpg',
	'divide.jpg',
	'greater_london.jpg',
	'how_to_be_well_read.jpg',
	'inside_alcatraz.jpg',
	'jeeves_yule.jpg',
	'killer_wall.jpg',
	'rethink.jpg',
	'makers_hardcover.jpg',
	'marriage_game.jpg',
	'meeting_devil.jpg',
	'memory_illusion.jpg',
	'monaco.jpg',
	'snowdrift.jpg',
	'telltale_brain.jpg',
	'ten_types_human.jpg',
	'the_orphans.jpg',
	'wodehouse1.jpg',
];

const end_books = [
  'makers.jpg',
  'wodehouse2.jpg',
	'wodehouse3.jpg'
];

shuffleArray(extra_books);

const all_books = [...initial_books, ...extra_books, ...end_books];

const books = all_books.map(book => {
  return <Image noLazyLoad="true" placeholderColor="#F1EBE4" width="1000" height="auto" key={book} src={require(`./books/${book}`)} alt="" className="book" />
});

const About = () => (
  <div>
    <div className="container about">
      <p>Hi! I’m a freelance book cover designer. <br />
      I've spent most of my career living and working in London,<br /> but I am now based in Cape Town, living the dream!</p>
    </div>
    <footer className="fixed-footer">&copy; Natascha Nel 2018</footer>
  </div>
);

const Contact = () => (
  <div>
    <div className="container contact">
    <p>
      <span>To get in touch, please email<br /> me at <a href="mailto:hello@nataschanel.com">hello@nataschanel.com</a><br /> or you can find me on</span>
      <span>
        <a href="https://www.facebook.com/natascha.spargo" target="_blank" rel="noopener noreferrer"><img alt="Facebook" class="social-icon" src={iconFb} /></a>
        <a href="https://www.instagram.com/natascha_nel/" target="_blank" rel="noopener noreferrer"><img alt="Instagram" class="social-icon" src={iconInstagram} /></a>
        <a href="https://www.linkedin.com/in/nataschaspargo/" target="_blank" rel="noopener noreferrer"><img alt="LinkedIn" class="social-icon" src={iconLinkedIn} /></a>
      </span>
    </p>
    </div>
    <footer className="fixed-footer">&copy; Natascha Nel 2018</footer>
  </div>
);

const Home = () => (
  <div>
    <div id="books">
      {books}
    </div>
    <div className="up"><ScrollToTop style={{bottom:'30px', right:'25px'}} showUnder={160}>↑</ScrollToTop></div>
    <footer className="rel-footer">&copy; Natascha Nel 2018</footer>
  </div>
);

class NN extends Component {

  render() {
    return (
      <Router>

        <div className="nn">

          <nav>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><span className="middot">&middot;</span></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>

          <div className="intro">
            <Link className="homelink" to="/"><img className="logo" src={logo} alt="Natascha Nel" /></Link>
            <h1>Natascha Nel</h1>
            <p>Freelance Book Cover Designer<br /><a href="mailto:hello@nataschanel.com">hello@nataschanel.com</a></p>
          </div>

          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />

        </div>
      </Router>
    );
  }
}

export default NN;



// WEBPACK FOOTER //
// ./src/NN.js